import { Injectable } from '@angular/core';
import { Observable, Subject } from '../../../node_modules/rxjs';
import { Alert } from '../clases/alert';
import { Router, NavigationStart } from '../../../node_modules/@angular/router';
import { Confirmation, Message } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private subject = new Subject<Alert>();
  private keepAfterRouterChange = false;
  public subjects = new Subject<Message>();
  public Config = new Subject<Confirmation>();
  constructor(private router: Router) { 
    router.events.subscribe(event => {
      if(event instanceof NavigationStart){
        this.keepAfterRouterChange = false;
      }else{
        this.clear();
      }
    }); 
  }

  getAlert(): Observable<any>{
    return this.subject.asObservable();
  }

  success(title: string, message?: string){
    const alert = new Alert();
    alert.titleAlert = title;
    alert.messageAlert = message;
    alert.typeAlert = "success";
    this.alert(alert);
  }

  error(title: string, message?: string){
    const alert = new Alert();
    alert.titleAlert = title;
    alert.messageAlert = message;
    alert.typeAlert = "danger";
    this.alert(alert);
  }

  warning(title: string, message?: string){

    const alert = new Alert();
    alert.titleAlert = title;
    alert.messageAlert = message;
    alert.typeAlert = "warning";
    this.alert(alert);
  }

  secondary(title: string, message?: string){
    const alert = new Alert();
    alert.titleAlert = title;
    alert.messageAlert = message;
    alert.typeAlert = "secondary";
    this.alert(alert);
  }


  alert(alert: Alert){
    this.clear()
    this.keepAfterRouterChange = this.keepAfterRouterChange;
    this.subject.next(alert);
  }

  clear(){
    this.subject.next(null);
  }

  addInfo(titel:any,msg:any,life?:any){
    this.subjects.next({ severity: 'info', summary: titel, detail: msg, life: life });
  }
  addSuccess(titel:any,msg:any,life?:any){
      this.subjects.next({ severity: 'success', summary: titel, detail: msg, life: life });
  }
  addWarning(titel:any,msg:any,life?:any){
      this.subjects.next({ severity: 'warn', summary: titel, detail: msg, life: life});
  }
  addError(titel:any,msg:any,life?:any){
      this.subjects.next({ severity: 'error', summary: titel, detail: msg, life: life });
  }
  addCustom(titel:any,msg:any,life?:any){
    this.subjects.next({ severity: 'custom', summary: titel, detail: msg, life: life });
}
  showConfirm(Confi:Confirmation) {
      Confi.rejectButtonStyleClass= 'p-button-outlined p-button-sm',
      Confi.acceptButtonStyleClass= 'p-button-sm',       
      this.Config.next(Confi);           
  }

}
